import { atom } from "jotai";
import { RefObject } from "react";

// Atom to store actual ref of the Notebook Reference Panel
// to be able to exclude it in useOutsideClick for active page blocks
export const NotebookReferencePanelRefAtom = atom<RefObject<HTMLElement>>();
